if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"borrow","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(208|253|777|926)|3((|09|2)4|148|302|442|546)|4((15|3|83)8|121|893)|6(638|716|933)|7(066|458|624|632)|8((0|59|81)4|355|448|920|952)|2192|2585|5296|9236|9872)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}